// The CC BY 4.0 credit line for a loop (matches the Licence page):
// “<title or Loop>” by <nickname>, The Infinite, CC BY 4.0, <loop page URL>
export function attribution(loop: {
  title: string | null;
  author: string | null;
  kind: "human" | "filler" | string;
  url: string;
}): string {
  const who = loop.kind === "filler" ? "The Infinite (Wizard filler)" : (loop.author ?? "former contributor");
  return `“${loop.title || "Loop"}” by ${who}, The Infinite, CC BY 4.0, ${loop.url}`;
}
